import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';

export type FeatureFlagScopeType = 'TENANT' | 'USER';

export const operatorFeatureFlagApi = {
  listFeatureFlags: (params?: { includeArchived?: boolean }) =>
    api.get<ApiResponse<any[]>>('/operator/feature-flags', { params }),

  createFeatureFlag: (data: {
    key: string;
    name: string;
    description?: string | null;
    isEnabled?: boolean;
    defaultValue?: boolean;
    rolloutPercentage?: number;
    environments?: string[] | null;
    metadata?: Record<string, unknown>;
  }) => api.post<ApiResponse<any>>('/operator/feature-flags', data),

  updateFeatureFlag: (
    id: string,
    data: {
      name?: string;
      description?: string | null;
      isEnabled?: boolean;
      defaultValue?: boolean;
      rolloutPercentage?: number;
      environments?: string[] | null;
      metadata?: Record<string, unknown>;
    },
  ) => api.patch<ApiResponse<any>>(`/operator/feature-flags/${id}`, data),

  archiveFeatureFlag: (id: string) =>
    api.delete<ApiResponse<any>>(`/operator/feature-flags/${id}`),

  setFeatureFlagOverride: (
    id: string,
    data: {
      scopeType: FeatureFlagScopeType;
      scopeId: string;
      enabled: boolean;
      reason?: string | null;
    },
  ) => api.put<ApiResponse<any>>(`/operator/feature-flags/${id}/overrides`, data),

  clearFeatureFlagOverride: (
    id: string,
    scopeType: FeatureFlagScopeType,
    scopeId: string,
  ) =>
    api.delete<ApiResponse<any>>(
      `/operator/feature-flags/${id}/overrides/${scopeType}/${scopeId}`,
    ),

  evaluateFeatureFlag: (
    data: { key: string; environment?: string },
    params?: { tenantId?: string; userId?: string; environment?: string },
  ) =>
    api.post<
      ApiResponse<{
        key: string;
        enabled: boolean;
        reason: string;
        flagId?: string;
        rolloutBucket?: number;
      }>
    >('/operator/feature-flags/evaluate', data, { params }),
};
